import { Component } from '@angular/core'
import { CurrentProductService } from '@spartacus/storefront'
import { distinctUntilChanged, filter, map, switchMap, tap } from 'rxjs/operators'
import { MbProductTabExtendedValidationConnector } from '../../../connectors/extended-validation'
import { PdpGalleryService } from '../../../../shared/services/pdp-gallery.service'
import {
  MbDataset,
  MbDatasetEntryType,
  MbHtmlDatasetEntry,
  MbImageDatasetEntry
} from '../../../../models'
import { isNotNullable } from '@spartacus/core'

@Component({
  selector: 'mb-pdp-extended-validation-tab',
  templateUrl: './pdp-extended-validation-tab.component.html',
  styleUrls: ['./pdp-extended-validation-tab.component.scss']
})
export class PdpExtendedValidationTabComponent {

  product$ = this.currentProductService.getProduct().pipe(
    filter(isNotNullable)
  )
  productName: string = ''
  mbDatasetEntryTypes = MbDatasetEntryType
  specificityGroup: {
    type: string;
    value: MbDataset[];
  }[] = []
  sensitivityGroup: {
    type: string;
    value: MbDataset[];
  }[] = []
  extendedValidation$ = this.product$.pipe(
    tap(product => this.productName = product.nameHtml ?? ''),
    map(product => product.originalCode),
    filter(isNotNullable),
    distinctUntilChanged(),
    switchMap(productCode => this.mbProductTabExtendedValidationConnector.get(productCode)),
    tap(extendedValidation => {
      this.specificityGroup = this.populateDetailedInfo(extendedValidation.specificityEntries)
      this.sensitivityGroup = this.populateDetailedInfo(extendedValidation.sensitivityEntries)
    })
  )

  constructor (protected currentProductService: CurrentProductService,
              protected mbProductTabExtendedValidationConnector: MbProductTabExtendedValidationConnector,
              protected pdpGalleryService: PdpGalleryService) {
  }

  async openGalleryDialog (currentImageDataset: MbImageDatasetEntry,
                          imageGroupDataset: MbDataset[],
                          description: MbHtmlDatasetEntry[]) {
    try {
      await this.pdpGalleryService.openGalleryDialog({
        activeImage: this.pdpGalleryService.toActiveImageData(currentImageDataset, description[0].text as string),
        gallery: this.pdpGalleryService.toGalleryImageData(imageGroupDataset, description[0].text as string),
        hasApplicationData: true,
        productName: this.productName,
        position: 'Extended_validation'
      })
    } catch (_) {
    }
  }

  populateDetailedInfo (entries?: MbDataset[]): any {
    const entriesGroup: {
      type: string;
      value: MbDataset[];
    }[] = []
    let lastDetailInfoType: string | undefined
    entries?.forEach(info => {
      if (info?.type && info.type !== lastDetailInfoType) {
        lastDetailInfoType = info.type
        entriesGroup.push({ type: info.type, value: [info] })
      } else if (info?.type && info.type === lastDetailInfoType) {
        entriesGroup?.[entriesGroup?.length - 1]?.value?.push(info)
      }
    })
    return entriesGroup
  }
}
